import Configuration from "../config/configuration";
import axios from "axios";

class VehicleService {
  constructor() {
    this.config = new Configuration();
  }
  getNewCars(pageNo, pageSize, filterQuery, sortBy) {
    const { mk, md, bodyT, minP, maxP, featured, recent, upcoming, other } = filterQuery;
    const query = `${mk ? "&mk=" + mk : ""}${md ? "&md=" + md : ""}${minP ? "&minP=" + minP : ""}${maxP ? "&maxP=" + maxP : ""}${bodyT ? "&bodyT=" + bodyT : ""}${
      featured ? "&featured=" + featured : ""
      }${recent ? "&recent=" + recent : ""}${upcoming ? "&upcoming=" + upcoming : ""}${other ? "&other=" + other : ""}${sortBy ? "&sortBy=" + sortBy : ""}`;
    return axios.get(this.config.apiBaseUrl + `cars?page=${pageNo}&pageSize=${pageSize}${query}`);
  }
  getNewCarsVairant(pageNo, pageSize, filterQuery, sortBy) {
    const { mk, md, minP, maxP } = filterQuery;
    const query = `${mk ? "&mk=" + mk : ""}${md ? "&md=" + md : ""}${minP ? "&minP=" + minP : ""}${maxP ? "&maxP=" + maxP : ""}&sortBy=${sortBy}`;
    return axios.get(this.config.apiBaseUrl + `cars/variants?page=${pageNo}&pageSize=${pageSize}${query}`);
  }
  getNewBikes(pageNo, pageSize, filterQuery, sortBy) {
    const { mk, md, minP, maxP, featured, recent, upcoming } = filterQuery;
    const query = `${mk ? "&mk=" + mk : ""}${md ? "&md=" + md : ""}${minP ? "&minP=" + minP : ""}${maxP ? "&maxP=" + maxP : ""}${featured ? "&featured=" + featured : ""}${
      recent ? "&recent=" + recent : ""
    }${upcoming ? "&upcoming=" + upcoming : ""}&sortBy=${sortBy}`;
    return axios.get(this.config.apiBaseUrl + `bikes?page=${pageNo}&pageSize=${pageSize}${query}`);
  }
  getCarById(id) {
    return axios.get(this.config.apiBaseUrl + `cars/${id}`);
  }
  getBikeById(id) {
    return axios.get(this.config.apiBaseUrl + `bikes/${id}`);
  }

  getRecentReviews(formData) {
    const { type, pageNo, pageSize } = formData;
    return axios.get(this.config.apiBaseUrl + `reviews/recent?page=${pageNo}&pageSize=${pageSize}&category=${type}`);
  }

  getMakeReviews(formData) {
    const { type, pageNo, pageSize, makeId } = formData;
    return axios.get(this.config.apiBaseUrl + `reviews?category=${type}&makeId=${makeId}`);
  }

  getModelReviews(formData) {
    const { type, pageNo, pageSize, modelId } = formData;
    return axios.get(this.config.apiBaseUrl + `reviews?category=${type}&modelId=${modelId}`);
  }

  getCarSeoCrumb() {
    return axios.get(this.config.apiBaseUrl + `cars/seo`);
  }
  getBikeSeoCrumb() {
    return axios.get(this.config.apiBaseUrl + `bikes/seo`);
  }

  getCarSeoCrumbInside(make, model) {
    return axios.get(this.config.apiBaseUrl + `cars/seo/inside?make=${make}&model=${model}`);
  }
  getBikeSeoCrumbInside(make, model) {
    return axios.get(this.config.apiBaseUrl + `bikes/seo/inside?make=${make}&model=${model}`);
  }

  handleError(error) {
    console.log(error.message);
  }
}
export default VehicleService;
